// extracted by mini-css-extract-plugin
export default {"box":"WeekTimeline_box__ATWUG"};